import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import CookieConsent from './CookieConsent';
import Canonical from './Canonical';
import './Layout.css';
import { Analytics } from '@vercel/analytics/react';

const Layout = ({ children }) => {
  const [cookieConsent, setCookieConsent] = useState(null);

  useEffect(() => {
    // Check cookie consent status
    const consent = localStorage.getItem('cookieConsent');
    if (consent) {
      setCookieConsent(consent);
    } else {
      // Default to pending if no choice made yet
      setCookieConsent('pending');
    }
  }, []);

  // Show analytics if user accepted all or essential only
  const showAnalytics = cookieConsent === 'accepted' || cookieConsent === 'essential';

  return (
    <div className="app-layout bg-background-light">
      <Canonical />
      <Navbar />
      <main className="main-content">
        {children}
      </main>
      <Footer />
      {showAnalytics && <Analytics />}
      <CookieConsent />
    </div>
  );
};

export default Layout;
